export default __webpack_public_path__ + "static/media/space-key.617c0a35.svg";